/*!

 =========================================================
 * Vue Argon Design System - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/argon-design-system
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

 * Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
//import wysiwyg from "vue-wysiwyg";
import VS2 from 'vue-script2'
import Vuex from 'vuex'
import axios from 'axios';
import Editor from 'vue-editor-js/src/index'
import VueTimeline from "@growthbunker/vuetimeline";
import VueMeta from 'vue-meta'
import {Base64} from 'js-base64';

import vueKanban from 'vue-kanban';
import VueSuggestion from 'vue-suggestion';
//import VueInstagram from 'vue-instagram';
import * as dotenv from 'dotenv'

export const eventBus = new Vue();


import '../vue.custom.config';
import SimpleFlowchart from 'vue-simple-flowchart';
//import 'vue-simple-flowchart/dist/vue-flowchart.css';
import ErrorService from "./models/ErrorService.js";
//import Buefy from 'buefy';


import storePlugin from './storePlugin'
import UserModel from "./models/UserModel";
import "leaflet/dist/leaflet.css";
import { Icon } from 'leaflet';
import { loadScript } from "vue-plugin-load-script";
import Api from "./models/Api.js";
import bridge from "@vkontakte/vk-bridge";
import Editorjsrender from "./models/Editorjsrender";


// (async function() {
// 	await loadScript('https://telegram.org/js/telegram-web-app.js');

// 	if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
// 		localStorage.setItem("tg_inside_init_data", JSON.stringify(window.Telegram.WebApp.initData));
//
// 		window.Telegram.WebApp.ready();
// 	}
// })();



const config = dotenv.config()
if(config.error){

}

//console.log('current host is',{"host":window.location.host});

Vue.use(Argon);
Vue.use(VS2);
Vue.use(VueMeta);
//Vue.use(wysiwyg, {});
Vue.use(Vuex);
Vue.use(storePlugin);
//Vue.use(Buefy);
Vue.use(Editor);
Vue.use(vueKanban);
Vue.use(VueSuggestion);
//Vue.config.errorHandler = (error) => ErrorService.onError(error);
Vue.use(VueTimeline, {
	// Specify the theme to use: dark or light (dark by default).
	theme: "light",
});
if(process.env.MAIN_DAY_COLOR){
	Vue.config.MAIN_DAY_COLOR=process.env.MAIN_DAY_COLOR;
}
if(process.env.MAIN_NIGHT_COLOR){
	Vue.config.MAIN_NIGHT_COLOR=process.env.MAIN_NIGHT_COLOR;
}

if(process.env.IS_SAAS_APPLICATION=="1" && process.env.MAIN_DOMAIN
&& process.env.API_DOMAIN){
 var current_host=window.location.host;

 var subdomain=current_host.replace(process.env.MAIN_DOMAIN,"");

 if(subdomain.length>0 && subdomain!=current_host) {
	 Vue.config.API_URL           = "https://" + subdomain + process.env.API_DOMAIN + "/api/";
	 Vue.config.USER_AGREMENT     = "https://yandex.ru"
	 Vue.config.URL_LOGOTYPE      = "https://" + current_host + "/"+subdomain+"logo.png";
	 Vue.config.URL_LOGOTYPE_DARK = "https://" + current_host + "/"+subdomain+"logo_night.png"
	 Vue.config.IMAGE_URL         = "https://" + subdomain + process.env.API_DOMAIN + "/";
	 Vue.config.BASE_URL          = "https://"+current_host+"/";
	 Vue.config.BASE_URL_FRONT    = "https://"+current_host+"/";
 }

}else {

	Vue.config.API_URL=process.env.API_URL;
	Vue.config.USER_AGREMENT=process.env.USER_AGREMENT_URL;
	Vue.config.URL_LOGOTYPE=process.env.URL_LOGOTYPE;
	if(process.env.URL_LOGOTYPE_DARK){
		Vue.config.URL_LOGOTYPE_DARK=process.env.URL_LOGOTYPE_DARK;
	}else {
		Vue.config.URL_LOGOTYPE_DARK=process.env.URL_LOGOTYPE;
	}
	if(process.env.AUTH_REQUIRED && parseInt(process.env.AUTH_REQUIRED)===1){
		Vue.config.AUTH_REQUIRED=1;
	}
	if(process.env.DISABLE_NOTIFY_TYPES && parseInt(process.env.DISABLE_NOTIFY_TYPES)==1){
		Vue.config.DISABLE_NOTIFY_TYPES=1;
	}
	if(process.env.ADDITIONAL_CSS){
		Vue.config.ADDITIONAL_CSS=process.env.ADDITIONAL_CSS;
	}

	Vue.config.BASE_LOGIN_URL=process.env.BASE_LOGIN_URL;
	Vue.config.OAUTH=process.env.OAUTH;
	Vue.config.OAUTH_providers=process.env.OAUTH_providers;


	Vue.config.IMAGE_URL=process.env.IMAGE_URL;
	Vue.config.BASE_URL=process.env.BASE_URL;
	Vue.config.BASE_URL_FRONT=process.env.BASE_URL_FRONT;
	Vue.config.TG_BOT = process.env.TG_BOT;
	Vue.config.MATRIX_AUTH_ENABLE=process.env.MATRIX_AUTH_ENABLE;
	Vue.config.MATRIX_BOT=process.env.MATRIX_BOT;
}


// Vue.config.currencys=JSON.parse(process.env.CURRENCYS);
// Vue.config.currencys_title=JSON.parse(process.env.CURRENCYS_TITLE);


Vue.use(loadScript);


const startPromise = new  Promise((resolve, reject) => {




	UserModel.check().then(function(result){
		resolve(result);
	});



});

// loadScript("https://unpkg.com/matrix-widget-api@1.1.1/dist/api.min.js").then(function(){
// 	try {
// 		const params_qs = new Proxy(new URLSearchParams(window.location.search), {
// 			get: (searchParams, prop) => searchParams.get(prop),
// 		});
// 		Api.loginByWidgetMatrix(window.location.hash);
// 		Api.loginByWidgetMatrix(params_qs.megaSecretUserId);
//
// 		function parseFragment() {
// 			const fragmentString = (window.location.hash || "?");
//
// 			return new URLSearchParams(fragmentString.substring(Math.max(fragmentString.indexOf('?'), 0)));
// 		}
//
// 		function assertParam(fragment, name) {
// 			const val = fragment.get(name);
// 			if (!val) throw new Error(`${name} is not present in URL - cannot load widget`);
// 			return val;
// 		}
//
//
//
//
// 		const qs = parseFragment();
//
//
// 		const userId = assertParam(qs, 'userId');
//
//
//
// 		if(window.mxwidgets && window.mxwidgets.WidgetApi){
//
// 			if(userId){
// 				Api.loginByWidgetMatrix(userId,function(data){
//
// 					UserModel.set(data.user,false);
// 					window.location.replace(location.pathname);
//
// 				})
// 			}
//
//
//
//  		const widgetApi = new window.mxwidgets.WidgetApi(widgetId);
// 		widgetApi.requestCapability(window.mxwidgets.MatrixCapabilities.AlwaysOnScreen);
//
// 		widgetApi.on("ready", function() {
//
// 		});
//
//  		widgetApi.start();
//
// 		}
//
// 	} catch (e) {
//
//
// 	}
// });





router.beforeEach(async (to, from, next) => {


	eventBus.$emit("route_is_change",{"from":from,"to":to});
	//await loadScript('https://telegram.org/js/telegram-web-app.js');

	if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
		localStorage.setItem("tg_inside_init_data", JSON.stringify(window.Telegram.WebApp.initData));

		window.Telegram.WebApp.ready();
	}

	if ((window.location.hash && window.location.hash.length > 0 && window.location.hash.includes('tgWebAppData'))) {
		localStorage.setItem("tgHash", Base64.encode(window.location.hash));
		var json_arr={};
		json_arr["hashTG"]=window.location.hash;
		localStorage.setItem("tgHashJS",JSON.stringify(json_arr));


	}




	if(to.name=="wait_activate"){
		var result_login = await UserModel.checkActivate();
	}


	if((to.name!="login" && to.name!="wait_activate" ) && Vue.config.AUTH_REQUIRED==1) {
		var result_login = await UserModel.checkActivate();




		if(result_login==2){
			next();
		}else if(result_login==1){

			next({
				path: '/wait_activate'
			});
		}else if(result_login==0){
			UserModel.logout();
			next({
				path: '/login',
				query: { nextUrl: to.fullPath }
			});
		}

	}

	// startPromise.then(function(result_login){
	// 	if(to.matched.some(record => record.meta.need_login)) {
	//
	//
	// 		if(result_login){
	// 			next();
	// 		}else {
	//
	// 			next({
	// 				path: '/',
	// 				query: { nextUrl: to.fullPath }
	// 			});
	// 		}
	//
	//
	// 	}else {
	// 		next();
	// 	}
	// });
	// if ((window.location.hash && window.location.hash.length > 0 && window.location.hash.includes('tgWebAppData'))) {
	//
	//
	// 	var result_login=await UserModel.check();
	//
	// 	if(result_login){
	// 		next();
	// 	}else {
	//
	// 		next({
	// 			path: '/login',
	// 			query: { nextUrl: to.fullPath }
	// 		});
	// 	}
	// }else
	//{

		if(to.matched.some(record => record.meta.need_login) || ( (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) && (to.name!="login" && to.name!="wait_activate" ) )) {

			var result_login=await UserModel.check();

			if(result_login){
				next();
			}else {
				UserModel.logout();

				next({
					path: '/login',
					query: { nextUrl: to.fullPath }
				});
			}





		}else {
			var result_login=await UserModel.check();
			if(result_login==false){
				UserModel.logout();
			}
			next();
		}

	//}



});


var filter = function(text, length, clamp){
	clamp = clamp || '...';
	var node = document.createElement('div');
	node.innerHTML = text;
	var content = node.textContent;
	return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);


Vue.mixin({
	methods: {
		Logout() {
			var app = this;
			UserModel.logout();

			app.$router.push({'path':"/"});
		}


	}
});



Vue.component("editorjsrender",Editorjsrender);
Vue.component('v-style', {
	render: function (createElement) {
		return createElement('style', this.$slots.default)
	}
});


Vue.mixin({
	methods: {
		setFooterExistLoader(result){
			this.$refs.footerBlock.setExistLoader(result);
		}
	}
})




const vm = new Vue({
	router,
	beforeCreate() {
		this.$store.commit('INITIALISATION_STORE');


	},
	beforeMount(){

	},
	render: h => h(App)
}).$mount("#app");

export {vm}